export const tw = {
  Navbar: {
    about_TOEIC: '多益攻略',
    must_know_vocabulary: '必考單字',
    Biz_talk: '真人口說',
    newsletter: '電子學習報',
    overview: '課程總覽',
    essay_revision: '寫作教室',
    email_sentence: 'E-mail 好用句',
    challenge: '單字挑戰',
    ai_helper: 'AI 小助教'
  },
  Course_Overview: {
    cefr_level: 'CEFR 分級',
    A1: '（基礎級 TOEIC<225）',
    A2: '（初級 TOEIC 225-550）',
    B1: '（中級 TOEIC 550-785）',
    B2: '（中高級 TOEIC 785-945）',
    C1: '（高級 TOEIC>945）',
    C2: '（精熟級 TOEIC>945）',
    course_category: '課程類別',
    life: '生活',
    biz: '商業',
    news: '新聞',
    toeic: '多益',
    learning_resources: '學習資源',
    unit_test: '單元測驗',
    passed: '已通過',
    unpassed: '未通過'
  },
  Login: {
    register: '我要報名',
    trial: '申請試用',
    login: '登入',
    log_out: '登出',
    start_my_course: '登入學習',
    // please_enter_your_email: '請輸入電子信箱...',
    please_enter_password: '請輸入密碼',
    forgot_Password: '忘記密碼',
    please_enter_your_email: '請輸入註冊信箱',
    send_verification_email: '發送驗證信'
  },

  Overview: {
    classify: '學前測驗',
    time: '學習總時數',
    course: '通過單元測驗課數',
    practice: '通過課後挑戰',
    exam: '完成月考數',
    exam_score: '月考分數',
    exam_advance: '任一月考>學前測驗',
    exam_advance_with_percent: '月考進步百分比',
    writing_count: '完成寫作篇數'
  },
  Home: {
    Daily_English: '每日一句',
    World_News: '全球新聞',
    Lets_play_in_English: '英文好好玩',
    FunEnglish: '跟著老師一起，玩遊戲、學單字、培養英語語感力!',
    Learning_History: '近期學習課程',
    Latest_Courses: '最新課程',
    Recommend: '推薦課程',
    Learning_Guides: '學習指引',
    Go_to_course: '前往課程',
    Play: '播放音檔',
    Keep: '收藏',
    watch_more: '看更多'
  },
  AI: {
    Home: {
      myPoints: '我的點數',
      pointUnit: '點',
      viewUsageRecords: '查看使用記錄',
      geptBeginner: 'GEPT初級',
      geptIntermediate: 'GEPT中級',
      pastExamQuestions: '歷屆考古題',
      mockTest: '模擬試題',
      letterGenerator: '書信生成',
      aiCorrection: 'AI批改',
      speechScriptGenerator: '演講稿生成',
      shadowingPractice: '跟讀練習',
      noAiPointsDeducted: '(不扣點)',
      guide: '使用指南',
      generateLetter: '生成書信',
      generateSpeech: '生成演講稿',
      businessScenario: '商業情境',
      lifeScenario: '生活情境'
    },
    Records: {
      backToAIHelper: '返回AI小助教',
      serialNumber: '序號',
      usageTime: '使用時間',
      item: '項目',
      pointsDeducted: '扣除點數',
      goTo: '前往',
      noUsageRecords: '尚無使用紀錄',
      redeemConfirmTitle: '確認兌換AI英語學習教室 {points}點?',
      currentTotalPoints: '目前總點數：',
      addPoints: '增加 {points} 點',
      pointsAfterRedeem: '增加後點數',
      confirm: '確認',
      cancel: '取消',
      errorOccurred: '發生錯誤',
      redeemComplete: '兌換完成',
      redeemFailed: '兌換失敗',
      redeemConfirmation: '兌換確認'
    }
  },
  GEPT: {
    common: {
      geptPractice: 'GEPT 模擬練習',
      quizWriting: '學測寫作',
      points: '點',
      logout: '登出',
      practiceOverview: '練習總覽',
      roundOverview: '回數總覽',
      beginnerAndIntermediate: '初級與中級',
      mockAndPast: '模擬試題與歷屆考古題',
      speakingAndWriting: '口說與寫作',
      speaking: '口說',
      writing: '寫作',
      speakingPractice: '口說練習',
      writingPractice: '寫作練習',
      practiceCount: '練習次數',
      notStarted: '尚未開始練習',
      expiredRedeemAgain: '有效期已過，請重新扣點',
      validTime: '有效時間：{date}',
      noRecord: '尚無紀錄',
      viewRecord: '查看紀錄',
      startPractice: '開始練習',
      enterPractice: '進入練習',
      selectPracticeItem: '請選擇要練習的項目',
      question: '題目',
      answer: '回答',
      start: 'START',
      nextQuestion: '下一題',
      nextType: '前往下一個題型',
      submitReport: '交卷看報告',
      confirm: '確認',
      back: '返回',
      notice: 'Notice',
      errorOccurred: '發生錯誤',
      noExamRecord: '無法取得考試紀錄，請稍後再試',
      wordsCount: '已輸入 {count} 個單字',
      inputWords: '作答字數：{count} 字',
      wordUnit: '字',
      scoreUnit: '分',
      noAnswer: '尚無作答內容',
      correction: '批改',
      aiCorrection: 'AI批改',
      downloadReport: '下載報告',
      totalScore: '總分',
      referenceAnswer: '參考答案',
      chineseTranslation: '中文翻譯：'
    },
    labels: {
      beginner: '初級',
      intermediate: '中級',
      mockExam: '模擬試題',
      pastExam: '歷屆考古題',
      allQuestions: '全部題目',
      repeat: '複誦',
      readSentences: '朗讀句子與短文',
      answerQuestion: '回答問題',
      describeImage: '描述圖片',
      readPassage: '朗讀短文',
      describePicture: '看圖敘述',
      singleSentenceWriting: '單句寫作',
      paragraphWriting: '段落寫作',
      chineseToEnglish: '中譯英',
      englishComposition: '英文作文',
      sentenceRewrite: '句子改寫',
      sentenceMerge: '句子合併',
      sentenceReorder: '句子重組',
      pictureWriting: '看圖表寫作',
      firstPart: '第一部分',
      secondPart: '第二部分',
      thirdPart: '第三部分',
      fourthPart: '第四部分',
      fifthPart: '第五部分',
      sixthPart: '第六部分',
      partWithNumber: '第{number}部分'
    },
    alerts: {
      answerHint: '作答提示',
      unfinishedSentence: '<p>尚有句子未完成</p>',
      scoreFailedTitle: '成績計算失敗',
      scoreFailedText: '請稍後再試或聯絡客服',
      confirmCompleteTitle: '確認完成 {name} {type} 題型練習?',
      aiCorrectionDesc: '按下確認鍵後，請稍待片刻由AI英語小助教立即為您進行AI批改。',
      currentTotalPoints: '目前總點數 {points} 點',
      pointsToDeduct: '需扣除 {points} 點',
      pointsAfterDeduct: '扣除後點數 {points} 點',
      calculatingScore: '成績計算中......',
      leaveTitle: '提醒',
      leaveText: '考試尚未完成，現在離開考試，作答不會送出產生記錄，請確認是否中斷本次考試。',
      continueAnswering: '繼續作答',
      confirmLeave: '確認前往',
      pointNotice: '扣點說明',
      askStart: '請問是否要開始',
      deductAfterConfirm: '按下確認後，將扣除{points}點。',
      currentTotalLabel: '目前總點數：',
      pointsToDeductLabel: '需扣除：',
      pointsAfterDeductLabel: '扣除後點數：',
      insufficientPoints: '點數餘額不足',
      insufficientPointsDesc: '點數餘額不足支付本課程，請於LiveABC官網加購',
      purchaseUrl: '購買網址'
    },
    speaking: {
      clickToPlayQuestion: '點選後開始播放題目',
      playFinished: '播放完畢',
      listenCarefully: '請仔細聆聽',
      answerAfterQuestion: '問題播完後，<br>麥克風將會開啟錄音，<br>請在時間內回答完成。',
      pleaseAnswerQuestion: '請回答問題',
      recordingFinished: '錄音完畢',
      confirmRecording: '確認錄製',
      recordingSuccess: '錄製成功',
      recordedNext: '確認已錄製，<br>前往下一題。',
      skipCountdown: '跳過倒數，開始作答',
      beginnerReadHint: '倒數60秒時，請先閱讀題目，<br>在時間內將全部朗讀完成。',
      readHint: '請先閱讀題目，閱讀時間結束倒數時，麥克風將會自動開啟錄音，請在時間內回答完成。',
      recordingComplete: '錄音完成',
      timeUpSubmit: '作答時間已到，請交卷',
      recordingItem: '正在錄製 S{number}',
      stopAfterReading: '唸完請點選停止鍵。'
    },
    writing: {
      rewriteInstruction: '請依題目之提示，將原句改寫成指定型式，並將改寫的句子完整地寫在答案卷上（包括提示之文字及標點符號）。',
      placeholderAnswer: '請作答 ...',
      sectionTitle: '第{label}部分　{name}',
      uploadImage: '上傳圖片',
      questionTitle: '題目',
      clearAnswer: '清除作答框',
      translateDescription: '請將以下中文句子翻譯成正確、通順、達意的英文。',
      compositionDescription: '請依提示寫一篇英文作文，文長至少120個單詞。',
      paragraphDescription: '請根據以下的圖片寫一篇約50字的短文。\n注意：未依提示作答者，將予扣分。',
      paragraphHint: '【段落寫作】這個部分的寫作採整體式的評分再轉換成百分制，需要花費的時間跟分數比重都較多，需要閱讀提示的文字用英文描寫出圖片情節約50字的短文，評分的重點包含文字表達完整度、文法、拼字、大小寫、標點符號等。<br/><br/>文章第一句可先說明全文主旨，接著內容依照時間順序描寫、切記不要離題或加入不相關的內容，中間善用轉折詞能讓文章結構更為清楚，最後結論可以加入自己對這件事的看法或感受。 試著用關鍵字先描述圖片中的動作或情節，注意時態是過去式或是現在式並且把3張圖片都串聯起來，把各個句子連接起來之後，要再注意文法上有沒有使用錯誤尤其是動詞時態、名詞單複數。'
    },
    testing: {
      audioPlayTest: '音檔播放測試',
      audioPlayDesc: '請點選播放後，確認聲音播放是否正常。',
      micTest: '麥克風測試',
      micDesc: '請對著麥克風說話，線條產生波動，代表麥克風正常。',
      inputTest: '輸入測試',
      inputPlaceholder: '點此輸入......',
      inputDesc: '請在框內輸入英文，確認設備與輸入法有正常運作。'
    },
    precautions: {
      beginnerSingleSentenceWriting: '本測驗包含兩部分：單句寫作、段落寫作。其中，單句寫作又分為「句子改寫、句子合併、句子重組」三個大題。<br/>測驗時間為40分鐘。請點選下方「START」開始進行測驗。',
      beginnerParagraphWriting: '本測驗包含兩部分：單句寫作、段落寫作。其中，段落寫作是根據題目說明以及提供的三格圖片寫一篇約50字的短文。<br/>測驗時間為40分鐘。請點選下方「START」開始進行測驗。',
      beginnerRepeat: '本測驗包含三個部分：「複誦、朗讀句子與短文、回答問題」。其中，第一部分複誦共五題，題目由耳機播出，每題播出兩次，兩次之間大約有一至兩秒的間隔。聽完兩次後，請馬上複誦一次。<br/>測驗時間共約10分鐘。請點選下方「START」開始進行測驗。',
      beginnerReadSentences: '本測驗包含三個部分：「複誦、朗讀句子與短文、回答問題」。其中，第二部分朗讀句子與短文共有五個句子及一篇短文，請利用一分鐘的時間閱讀題目的句子與短文，然後在一分鐘內以正常的速度，清楚、正確地朗讀一遍，閱讀時請不要發出聲音。<br/>測驗時間共約10分鐘。請點選下方「START」開始進行測驗。',
      beginnerAnswerQuestion: '本測驗包含三個部分：「複誦、朗讀句子與短文、回答問題」。其中，第三部分回答問題共七題。題目由耳機播出，每題播出兩次，兩次之間大約有一至兩秒的間隔。聽完兩次後，請馬上回答；每題回答時間為15秒。<br/>測驗時間共約10分鐘。請點選下方「START」開始進行測驗。',
      intermediateChineseToEnglish: '本測驗共有兩部分。第一部分為「中譯英」，第二部分為「英文作文」。<br/>測驗時間為40分鐘。請點選下方「START」開始進行測驗。',
      intermediateEnglishComposition: '本測驗共有兩部分。第一部分為「中譯英」，第二部分為「英文作文」。<br/>測驗時間為40分鐘。請點選下方「START」開始進行測驗。',
      intermediateReadPassage: '本測驗包含三個部分：「朗讀短文、回答問題、看圖敘述」。其中，第一部分朗讀短文，請先利用一分鐘的時間閱讀題目短文，然後在兩分鐘內以正常的速度，清楚、正確地讀出題目短文，閱讀時請不要發出聲音。<br/>測驗時間共約10分鐘。請點選下方「START」開始進行測驗。',
      intermediateAnswerQuestion: '本測驗包含三個部分：「朗讀短文、回答問題、看圖敘述」。其中，第二部分回答問題共十題。題目已事先錄音，每題經由耳機播出兩次。第一至五題，每題回答時間15秒；第六至十題，每題回答時間30秒。每題播出後，請立即回答。<br/>測驗時間共約10分鐘。請點選下方「START」開始進行測驗。',
      intermediateDescribePicture: '本測驗包含三個部分：「朗讀短文、回答問題、看圖敘述」。其中，第三部分看圖敘述，題目包含一張圖片及四個相關的問題，請在一分半鐘內完成作答。<br/>測驗時間共約10分鐘。請點選下方「START」開始進行測驗。'
    },
    report: {
      answerReport: '作答報告',
      excellent: '很棒',
      acceptable: '尚可',
      needsImprovement: '待加強',
      subtest: '分項測驗',
      scoringCriteria: '評分項目',
      score: '得分',
      scoringSection: '評分部分',
      questionType: '測驗題型',
      summaryHeaderIntermediate: ['分項測驗', '評分項目', '得分'],
      summaryHeaderSpeaking: ['評分項目', '評分部分', '得分'],
      summaryHeaderWriting: ['評分部分', '測驗題型', '得分'],
      translationGroup: '第一部分：中譯英（40%）',
      compositionGroup: '第二部分：英文作文（60%）',
      translationCriteria: '用字遣詞、文法、拼字、標點符號及大小寫',
      compositionCriteria: '內容適切性、組織、字彙及句型、文法、拼字及標點符號',
      singleSentenceGroup: '第一部分:單句寫作(50%)',
      paragraphGroup: '第二部分:段落寫作(50%)',
      sentenceRewriteType: 'A.句子改寫',
      sentenceMergeType: 'B.句子合併',
      sentenceOrderType: 'C.重組',
      pictureWritingType: 'D.看圖表寫作',
      speakingAllParts: '第一、二、三部分',
      speakingThirdPart: '第三部分',
      pronunciationCriteria: '發音、語調、流利度',
      grammarVocabularyCriteria: '文法、字彙之正確性和適切性',
      speakingFormula: 'GEPT官方網站分數計算公式：百分制總分之計算：（{a}+{b}）×10分﹦{score}分',
      speakingFormulaDefault: 'GEPT官方網站分數計算公式：百分制總分之計算：（A+B）×10分',
      intermediateWritingFormula: 'GEPT官方網站分數計算公式：【(第一部分之級分)×20分×40%】＋【(第二部分之級分)×20分×60%】',
      elementaryWritingFormula: 'GEPT官方網站分數計算公式：（（第一部分得分/30） + （第二部分得分/5））×50',
      previousType: '前往{type}',
      restartType: '此題型重新作答'
    },
    modal: {
      grading: '正在批改...',
      comprehensiveAdvice: '綜合建議',
      paragraphStructure: '段落架構：',
      structureAnalysis: '架構分析',
      content: '內容 Content：',
      organization: '組織 Organization：',
      grammar: '文法與句構 Grammar & Sentence Structure：',
      vocabulary: '字彙與拼字 Vocabulary & Spelling：',
      grammarSpellingAdvice: '文法與拼字建議',
      originalSentence: '原句：',
      revisionAdvice: '修改建議：',
      revisedSentence: '修正後句子：'
    },
    mic: {
      notAllowed: '請點擊網址列左方的鎖頭圖示，並允許存取麥克風。',
      notFound: '未偵測到麥克風裝置，請確認設備已接上或使用其他設備。',
      notFoundShort: '未偵測到麥克風裝置，請確認設備已接上。',
      notReadable: '麥克風可能被其他應用佔用，請稍後再試。',
      security: '請使用 HTTPS 網站開啟本功能。',
      default: '無法啟用麥克風，請確認裝置與瀏覽器設定。',
      unsupported: '此瀏覽器不支援麥克風功能，請使用 Chrome 或 Edge 開啟。',
      initFailed: '錄音元件初始化失敗，請重新整理或更換瀏覽器。',
      initFailedShort: '錄音元件初始化失敗',
      startFailed: '無法啟動錄音，請確認麥克風權限與裝置設定',
      startFailedShort: '無法啟動錄音',
      permissionDenied: '未授權麥克風，請至瀏覽器權限設定開啟。',
      noDevice: '未偵測到麥克風裝置，請使用其他設備或外接麥克風。'
    }
  },
  AiHome: {
    start: 'START',
    recent_route: {
      user_guide: '使用指南',
      letter_generate: '生成書信',
      speech_generate: '生成演講稿',
      ai_correction: 'AI批改',
      business_context: '商業情境',
      daily_context: '生活情境'
    },
    conversation: {
      business_english: '商業英語會話',
      daily_english: '生活英語會話',
      monthly_topic: '每月精選主題',
      adults_free_talk: '成人自由口說',
      kids_free_talk: '兒童自由口說'
    },
    intro: {
      service_features: '服務特色',
      service_features_desc: 'AI 小助教整合最先進 AI 語言處理技術，透過智能化演算法，協助您快速生成「商用書信」、「英文演講稿」，並提供 AI「口說練習」功能，無論是臨時需要寫一封英文 E-mail 給客戶、準備下一場重要的英文演說，或欲利用零碎時間自我提升英語口說會話實力，AI 小助教都是您可搭配使用的輔助工具。',
      points_desc_title: '點數說明',
      points_desc: '本區採點數制，依企業方案提供初始點數供學員體驗 AI 服務，如點數使用完畢歡迎加購，以繼續使用 AI 小助教各項服務。',
      guide: '使用說明',
      choose_type: '選擇類型',
      choose_type_desc: '請在左側選擇您需要生成的內容',
      input_data: '輸入資料',
      input_data_desc: '在指定欄位中以鍵盤輸入或直接說出相關資訊，點擊送出後，請稍作等待，由 AI 小助教為您完成目標任務。',
      view_result: '查看成果',
      view_result_desc: 'AI 小助教撰寫完畢後，請再次閱讀所生成內容是否符合所需，亦可依個人需求進行修改與調整。',
      more_features: '更多功能',
      more_features_desc: '歡迎點擊字典查詢、中文翻譯、全文播放、AI 代答、更多說明等延伸功能進行進一步學習。若想獲得更多靈感，請嘗試重新生成，或選擇不同情境，進行更多互動練習。'
    },
    common: {
      placeholder_answer: '請作答 ...',
      total_chars_pre: '共 ',
      total_chars_post: ' 字元',
      upload_image: '上傳圖片',
      start_correction: '開始批改',
      please_select: '請選擇',
      speaking_practice: '口說練習',
      japanese_speaking_practice: '日語口說練習',
      deduct_points: '生成每次扣除：',
      edit_letter_info: '修改信件資訊',
      edit_speech_info: '修改演講稿資訊',
      ph_disabled_summary: 'EX: 要誠摯邀請對方參與即將舉行的商業會議，共同探討機會，共創未來，會議時間在下個月13號。',
      confirm: '確認',
      return_edit: '返回修改',
      close: '關閉',
      clear: '清空',
      restart: '重新開始',
      on: '開',
      off: '關',
      cancel: '取消',
      audio_not_supported: '您的瀏覽器不支援音訊播放。'
    },
    follow: {
      title: '跟讀練習',
      input_hint: '請輸入文字，以進行跟讀練習',
      play_hint: '請點擊「全文播放」聆聽全文音檔，或點選右側麥克風進行逐句跟讀練習',
      record: '紀錄',
      title_excellent: 'EXCELLENT 太棒了!',
      title_great: 'GREAT 很厲害',
      title_good: 'GOOD 不錯喔',
      title_try_again: 'TRY AGAIN 再試一次',
      score_excellent: '很棒',
      score_good: '尚可',
      score_needs_improvement: '待加強',
      play_original: '原句播放',
      your_record: '你的錄音'
    },
    correction: {
      result_title: 'AI批改結果',
      upload_hint: '請輸入文字或點擊下方上傳圖片按鈕，將圖片轉為文字'
    },
    letter: {
      Letter: '商用書信',
      Sender_Information: '寄件人資訊',
      Sender_Name: '寄件人姓名',
      Sender_Company: '寄件人公司',
      Recipient_Information: '收件人資訊',
      Recipient_Name: '收件人姓名',
      Recipient_Company: '收件人公司',
      Letter_Information: '信件資訊',
      Subject: '信件主旨',
      Summary: '內容簡述（100字以內）',
      required: '*此欄位必填',
      ph_s_name: 'e.g. Emily',
      ph_s_company: 'e.g. ABC公司',
      ph_r_name: 'e.g. David',
      ph_r_company: 'e.g. XYZ公司',
      ph_subject: 'e.g. 專案合作細節洽談',
      ph_summary: 'e.g. 關於本次新產品專案合作細節，針對上市時程、合作細節、分潤模式，希望能約貴公司下週進行當面會談，以利雙方業務推展。'
    },
    speech: {
      English_Speech_Script: '英文演講稿',
      Speech_Information: '演講資訊',
      Topic: '主題',
      Type: '類型',
      Audience: '對象',
      Occasion: '場合',
      Summary: '內容簡述（100字以內）',
      ph_topic: 'e.g. 新產品介紹',
      ph_audience: 'e.g. 各大企業客戶',
      type_meeting: '會議簡報 Meeting Presentation',
      type_proposal: '企劃提案 Project Proposal',
      type_motivational: '激勵致詞 Motivational Speech',
      type_knowledge: '知識分享 Knowledge Sharing',
      type_elevator: '電梯簡報 Elevator Pitch',
      type_product: '產品示範 Product Demonstration',
      occ_internal: '內部專案會議 Internal Project Meeting',
      occ_external: '對外商務溝通 External Business Communication',
      occ_results: '成果發表與知識分享 Results Presentation and Knowledge Sharing',
      occ_motivation: '激勵與其他資訊傳達 Motivation and Other Information Delivery',
      ph_summary: 'e.g. 本次演講將發表最新上市的 AI 產品,針對產品優勢與特性說明,以協助各企業提升營運效率與創新競爭力。'
    },
    rule: {
      Total_Points: '目前總點數',
      Instructions: '操作說明',
      AI_Generation: 'AI 生成說明',
      AI_Review_Instructions: 'AI 批改說明',
      Note: '注意事項',
      Definition: '定義內容',
      privacy_and_security: '重視隱私與安全',
      review_again: '再次核對',
      per_letter_generation: '書信生成每次扣除',
      per_speech_generation: '演講稿生成每次扣除',
      per_AI_generation: 'AI批改每次扣除',
      Friendly_Reminder: '溫馨提醒',
      point: '點',
      letter: '書信',
      speech: '演講稿',
      commercial_letter: '商用書信',
      letter_inst_desc: '請先填寫寄件人與收件人資訊，再輸入信件資訊。',
      letter_def_desc: 'AI 小助教生成後，您可依據實際使用需求，進一步針對細部書信內容調整。',
      letter_privacy_desc: '在輸入資訊時，請謹慎不要透露自己或他人的個資或私人資訊。',
      letter_review_desc: '本篇商用書信為 AI 小助教自動生成，建議使用前再次斟酌核對相關細節。',
      speech_inst_desc: '請以中文填寫「主題」與「對象」資訊，並點選「類型」與「場合」，再以中文填寫「內容簡述」說明演講要點。',
      speech_gen_desc: '點擊「START」按鈕後，AI 將針對您的需求自動生成演講稿。',
      speech_note_desc: '生成前請確認輸入的文字內容，勿揭露公司與個人機密資訊。本演講稿由 AI 自動生成，請自行核對確認相關內容。',
      correct_inst_desc: '請輸入英文內容或點擊下方「上傳圖片」按鈕，並點選「開始批改」。',
      correct_review_desc: '點擊「開始批改」按鈕後，AI 將針對英文單字、文法、句構等進行檢視，並提供「文法與字彙修正」與「整體回饋」建議。原文中若有錯誤的地方，將以紅色顯示，讓您更容易發現問題並進行修正。AI 同時將自動依上傳內容生成「AI 範文」，提供更多參考建議。',
      correct_note_desc: '批改前請確認輸入的文字內容，勿揭露公司與個人機密資訊。本{type}由 AI 自動批改，請自行核對確認相關內容。',
      follow_mic: '請點選麥克風',
      follow_mic_desc: ' 開始錄音。',
      follow_play: '請點選原句播放',
      follow_play_desc: '，聆聽老師示範音檔。',
      follow_my_record: '請點選我的錄音',
      follow_my_record_desc: '，播放自己錄製的音檔。',
      follow_history: '請點選紀錄',
      follow_history_desc: '，查看個人錄音練習紀錄。'
    },
    swal: {
      rules_title: '使用規範',
      got_it: '我知道了',
      current_points: '目前總點數：',
      points_desc: '本區依企業方案提供初始點數供您體驗 AI 服務，<br/>每次使用以下服務將自動扣除點數。',
      speaking_practice: '口說練習：每次 1 點',
      business_letter: '商用書信：每次 20 點',
      speech_script: '英文演講稿：每次 20 點',
      insufficient_points: '點數不足',
      confirm_generate: '確定開始生成{type}？',
      confirm_correct: '確定開始批改{type}？',
      current_points_html: '目前總點數 <span style="color: #F30000;">{points}</span> 點',
      deduct_20_points: '需扣除 20 點',
      points_after_html: '扣除後點數 <span style="color: #F30000;">{points}</span> 點',
      contact_cs: '請洽客服人員加購點數',
      generate_fail: '生成失敗',
      generate_fail_msg: '糟糕！發生了一點小失誤，請再給我一次機會！',
      translate_success: '翻譯完成',
      system_error: '系統錯誤，請稍後再試',
      confirm_modify: '確定修改{type}資訊?',
      stay_on_page: '留在本頁',
      practice_deduct_desc: '當進行 AI 口說練習，每次送出後隨即扣除 1 點。',
      points_or_expired: '使用點數不足或時間過期',
      please_reinput: '請重新輸入',
      tips_html_2: '口說練習每次扣除：<span class="text-red-main-ai">1</span> 點',
      tips_html_3: '操作說明：',
      tips_html_4: '1. 點{img1}說出回應的句子，再點{img2}，送出後隨即扣點。',
      tips_html_5: '2. 點{img1}參考 AI 回應內容，並練習說說看。',
      tips_html_6: '3. 點{img1}輸入想翻譯的中文。',
      tips_html_7: '4. 點{img1}聆聽自己的錄音。',
      tips_html_8: '5. 點{img1}觀看 AI 反饋建議，讓自己下次說得更好。',
      tips_html_9: '6. 若 AI 回應不符預期，請修改文字內容或點擊重新整理。',
      device_test: '設備測試',
      device_test_desc: '請對著麥克風說話，線條會隨聲音波動。<br/>若無反應，請確認麥克風權限已開啟。'
    },
    result: {
      play_all: '全文播放',
      font_small: '字型變小',
      font_normal: '字型一般',
      font_large: '字型放大',
      translation: '中文翻譯',
      dict_mode: '字典模式',
      download: '下載',
      tab_grammar: '文法與字彙修正',
      tab_feedback: '整體回饋',
      tab_sample: 'AI範文',
      shadowing: '跟讀練習',
      grammar_advice_desc: '以下提供 {count} 項文法與字彙修正建議，希望能幫助你文法與用字更精準，以提升整體英文能力：',
      original_sentence: '原句：',
      suggestion: '建議：',
      explanation: '說明：',
      salutation: '開頭稱謂：',
      body: '信件本文：',
      closing: '結尾敬語與署名：',
      overall_feedback: '整體回饋：',
      copy_success: '複製成功',
      copy_fail: '發生錯誤'
    },
    chat: {
      chinese_input: '中文輸入',
      ai_suggest: 'AI代答',
      placeholder_active: '請點「麥克風」開始錄音應答，或點「AI」生成回應建議。',
      placeholder_disabled: '對話記錄僅供資料查看',
      submit: '送出',
      choose_topic: '請選擇主題，來場零壓力的互動對話練習吧！',
      speaking_practice: '口說練習',
      what_to_do_in_topic: '你想在 {topic} 做什麼呢？',
      scenario_shadowing: '情境跟讀練習',
      scenario_conversation: '情境對話練習',
      scenario_selection: '情境選擇',
      chinese_translation: '中文翻譯',
      you_have_selected: '你已選擇：',
      start_conversation_practice: '開始對話練習',
      start_stop_record: '開始/停止錄音',
      accent_us: '美國口音',
      accent_uk: '英國口音',
      accent_au: '澳洲口音',
      accent_in: '印度口音',
      play_audio: '播放原音',
      my_recording: '我的錄音',
      more_explanation: '更多說明',
      in_other_words: '換句話說',
      refresh: '重新整理',
      ph_translate_input: '請在此輸入您想翻譯的中文。',
      playback_speed: '播放速度',
      speed: '語速',
      text_display: '文字顯示',
      show_subtitle: '顯示字幕',
      hide_subtitle: '字幕關閉',
      save_settings: '儲存設定',
      chat_settings: '聊天設定',
      save_confirm_title: '儲存確認',
      save_confirm_msg: '請問您是否要儲存本次對話記錄，對話記錄儲存後可以再次開啟對話進行練習，並且觀看本次對話成果。',
      save_note: '備註：每組對話紀錄為唯一資料，若您想要以相同的對話主題，進行不同的口說練習，請按重新開始，開啟新的對話。',
      save_success: '儲存成功',
      view_records_score: '查看紀錄評分',
      continue_chatting: '繼續聊天',
      history_title: '我的對話記錄',
      rating_title: '我的對話評分',
      time: '時間',
      scene: '場景',
      topic: '主題',
      first_saved_at: '第一次儲存時間',
      last_updated_at: '最近一次更新',
      updated_at: '更新時間',
      scene_topic: '場景主題',
      function: '功能',
      sentence_score: '單句分數',
      chat_content: '聊天內容',
      continue_conversation: '繼續對話',
      sample_scene_topic: '機場>查詢航班',
      sample_voice_setting: '女聲 / 英國腔'
    },
    ocr: {
      popup_title: '圖片轉文字',
      step1: '選取與上傳',
      step2: '裁切圖片',
      step3: '開始辨識',
      step4: '辨識修正',
      upload_drag_hint: '拖移檔案到框內，或點選按鈕開啟資料夾上傳圖片',
      upload_limit_hint: '檔案需小於 10MB，圖片長寬像素必須小於 10000px',
      btn_upload: '上傳圖片',
      btn_reupload: '重新上傳圖片',
      btn_confirm_submit: '確認並送出',
      btn_confirm_text: '確認文字',
      btn_input_submit: '輸入',
      err_not_image: '請選擇圖片檔案（例如 .jpg、.png）',
      err_size_limit: '檔案大小不能超過 10MB',
      err_pixel_limit: '圖片尺寸不能超過 10000 像素',
      crop_guide_hint: '拖移邊框確認需裁切的圖片範圍',
      recognizing_hint: '辨識中，請稍後……',
      recognition_complete: '辨識完成！',
      recognition_fail_hint: '辨識失敗，請重新檢視圖片格式（小於 10MB）與圖片像素（長寬低於 10000px）是否符合相關上傳規定。',
      edit_hint: '可點選文字內容進行修正',
      recognition_warning_hint: 'AI 辨識文字結果會因字跡整齊、紙張整潔或照片清晰度之影響而有所不同，請務必重新檢視一遍並進行修正再確認上傳文章。'
    }
  },
  Course: {
    Description_video: '講解',
    Interactive_learning: '互動學習',
    Unit_test: '單元測驗',
    Practice: '課後挑戰',
    Record_study_time: '可累積學習時數'
  },
  HRCenter: {

  },
  Personal: {
    PersonalArea: '個人專區',
    Info: {
      Total_study_time: '學習總時數',
      Number_of_courses_passed: '通過單元測驗課數',
      Number_of_monthly_exams: '月考次數',
      First_time_login: '首次登入'
    },
    Updated_password: {
      Change_password: '修改密碼',
      Name: '姓名',
      Email: '帳號',
      Current_password: '輸入舊密碼',
      New_password: '輸入新密碼',
      Confirm_password: '密碼再確認',
      Save: '儲存',
      Company: '公司',
      Class: '班級',
      Period: '課程期間',
      Email_remind: '請輸入您的帳號',
      Change_account_remind: '帳號等同於主要信箱不可變更',
      Current_password_remind: '請輸入你的舊密碼',
      New_password_remind: '請輸入英文字母或數字的文字組合',
      Reenter_password_remind: '請再輸入一次您的新密碼'
    },
    Target: {
      Target: '學習目標',
      Goal: '目標',
      Result: '結果',
      Completed: '已完成',
      Point: '分',
      Unit: '課',
      Time: '次'
    },
    Record: {
      Learning_records: '學習紀錄',
      View_all: '總覽',
      Date_settings: '日期區間',
      Study_Time: '學習總時數',
      Number_of_completed_courses: '通過單元測驗課數',
      Number_of_review_test_passed: '通過課後挑戰數',
      Details: '詳細內容',
      Course_categories: '課程分類',
      History: '最近學習時間',
      Unit_test_score: '單元測驗分數',
      Go_to_course: '前往課程',
      Writing: '寫作紀錄'
    },
    Collection: {
      Keep: '我的收藏',
      Vocabulary: '單字',
      Lesson: '課程',
      Enter_course: '進入課程',
      Source_course: '來源課程'
    },
    Exam: {
      ExamArea: '測驗專區',
      Placement_test: '學前測驗',
      Result: '分級結果',
      Month: '考試月份',
      Exam_date: '測驗日期',
      Test_time: '使用時間',
      Listening_score: '聽力成績',
      Reading_score: '閱讀成績',
      Total_score: '總分',
      State: '狀態',
      Monthly_mock_test: '每月模考',
      More_practice: '更多練習',
      Updated_exam_date: '最近測驗日期',
      Number_of_exercises: '練習次數',
      Start: '開始',
      Details: '詳解'
      // : '',
      // : '',
      // : '',
      // : '',
      // : ''
    }
  }
}
